import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Button } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import OutboundLink from '../../atoms/OutboundLink';
import { EVENT_CATEGORIES, EVENT_ACTIONS } from '../../modules/analytics/components/Event';
import Event from '../../modules/analytics/components/Event/Event';
import Icon from '../../modules/foundation/components/Icon';
import { SocialMediaValue } from '../../services/proptypes';
import { extractMainHostnameFromDomain } from '../../utils/urls';
import './SocialMedia.css';
function getColor(colors, type) {
  if (colors === 'brand' && type) return type;
  if (colors !== 'primary' && colors !== 'secondary' && colors !== 'default') return colors;
  return null;
}
var SocialMedia = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SocialMedia, _React$PureComponent);
  var _super = _createSuper(SocialMedia);
  function SocialMedia() {
    _classCallCheck(this, SocialMedia);
    return _super.apply(this, arguments);
  }
  _createClass(SocialMedia, [{
    key: "mapValueToButton",
    value: function mapValueToButton(_ref) {
      var link = _ref.link,
        type = _ref.type,
        label = _ref.label;
      var _this$props = this.props,
        colors = _this$props.colors,
        buttonType = _this$props.buttonType,
        showLabels = _this$props.showLabels,
        inverted = _this$props.inverted,
        labelPosition = _this$props.labelPosition;
      var color = getColor(colors, type);

      // Figure out a valid and useful aria label
      var ariaLabel = label || type;
      if (!ariaLabel) {
        ariaLabel = extractMainHostnameFromDomain(link);
      }
      var ButtonComponent = /*#__PURE__*/React.createElement(Button, {
        "aria-label": ariaLabel,
        primary: colors === 'primary',
        secondary: colors === 'secondary',
        inverted: inverted,
        circular: buttonType === 'circle',
        color: color,
        icon: /*#__PURE__*/React.createElement(Icon, {
          iconName: type
        }),
        label: label,
        labelPosition: labelPosition === 'free' ? 'left' : labelPosition,
        type: "button"
      });
      if (!showLabels) {
        ButtonComponent = /*#__PURE__*/React.createElement(Button, {
          "aria-label": ariaLabel,
          primary: colors === 'primary',
          secondary: colors === 'secondary',
          inverted: inverted,
          circular: buttonType === 'circle',
          color: color,
          icon: /*#__PURE__*/React.createElement(Icon, {
            iconName: type
          }),
          type: "button"
        });
      }
      if (label && label !== '' && showLabels && labelPosition === 'free') {
        ButtonComponent = /*#__PURE__*/React.createElement(Button, {
          "aria-label": ariaLabel,
          primary: colors === 'primary',
          secondary: colors === 'secondary',
          inverted: inverted,
          circular: buttonType === 'circle',
          color: color,
          type: "button"
        }, /*#__PURE__*/React.createElement(Icon, {
          iconName: type
        }), label);
      }
      return /*#__PURE__*/React.createElement(Event, {
        key: "".concat(link, "-").concat(label, "-").concat(type),
        event: {
          category: EVENT_CATEGORIES.SOCIAL_EVENT_CATEGORY,
          action: EVENT_ACTIONS.SOCIAL_MEDIA_VIEW_EVENT_ACTION,
          label: type
        },
        eventType: "click"
      }, /*#__PURE__*/React.createElement(OutboundLink, {
        to: link,
        label: ariaLabel
      }, ButtonComponent));
    }
  }, {
    key: "renderButtonGroup",
    value: function renderButtonGroup() {
      var _this = this;
      var _this$props2 = this.props,
        socialMediaValues = _this$props2.socialMediaValues,
        groupButtons = _this$props2.groupButtons,
        groupVertically = _this$props2.groupVertically;
      if (groupButtons) {
        return /*#__PURE__*/React.createElement(Button.Group, {
          vertical: groupVertically
        }, socialMediaValues.map(function (value) {
          return _this.mapValueToButton(value);
        }));
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, socialMediaValues.map(function (value) {
        return _this.mapValueToButton(value);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        header = _this$props3.header,
        socialMediaValues = _this$props3.socialMediaValues;
      if (_isEmpty(socialMediaValues)) {
        return null;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "fc-social-media"
      }, header, this.renderButtonGroup());
    }
  }]);
  return SocialMedia;
}(React.PureComponent);
export { SocialMedia as default };
SocialMedia.defaultProps = {
  buttonType: 'circle',
  colors: 'default',
  groupButtons: false,
  groupVertically: false,
  header: '',
  inverted: false,
  labelPosition: 'free',
  showLabels: false
};
SocialMedia.propOptions = {
  colors: ['primary', 'secondary', 'default'],
  header: ['Social Media', 'Our Social Media Addresses', '']
};
SocialMedia.dataPropsMap = {
  socialMediaValues: ['business', 'social_media']
};